import { render, staticRenderFns } from "./BaseFiltersColor.vue?vue&type=template&id=088dfcf6&"
import script from "./BaseFiltersColor.vue?vue&type=script&lang=js&"
export * from "./BaseFiltersColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('088dfcf6')) {
      api.createRecord('088dfcf6', component.options)
    } else {
      api.reload('088dfcf6', component.options)
    }
    module.hot.accept("./BaseFiltersColor.vue?vue&type=template&id=088dfcf6&", function () {
      api.rerender('088dfcf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseFiltersColor.vue"
export default component.exports